export { default } from './ArticleLinkGroup';
export type { IArticleLinkGroup } from './ArticleLinkGroup';
